export default "__VITE_ASSET__B5z7STf9__"